<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Basic from "./basic";
import axios from "axios"

import {
  required,
  email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Registro de sitio",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Basic },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      info: null,
      title: "Registro de sitio",
      componentKey: 0,
      num_latitude: 0.0,
      num_longitude: 0.0,
      items: [
        {
          text: "Company",
          href: "/"
        },
        {
          text: "Sites",
          href: "/company/sites"
        },
        {
          text: "Site",
          active: true
        }
      ],
      companies: [],
      countries: [],
      states: [],
      cities: [],
      form: {
        id_company: "",
        id_country: "",
        id_state: "",
        de_addressSite: "",
        de_siteRepresentantEmail: "",
        de_siteHumanResourcesEmail: "",
        de_siteContactEmail: "",
        nm_site: "",
        num_latitude: 0,
        num_longitude: 0,
        yn_isCorporativeSite: false
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      id_company: { required },
      id_country: { required },
      id_state: { required },
      de_addressSite: { required, minLength: minLength(20), maxLength: maxLength(200) },
      de_siteRepresentantEmail: { required, email },
      de_siteHumanResourcesEmail: { required, email },
      de_siteContactEmail: { required, email },
      nm_site: {required, minLength: minLength(2), maxLength: maxLength(50)}
    }
  },
  watch:{
    lat(newLat, oldLat){
      if(newLat != oldLat){
        this.lat = newLat;
        this.forceRerenderMap();
      }
    },
    lng(newLng, oldLng){
      if(newLng != oldLng){
        this.lng = newLng;
        this.forceRerenderMap();
      }
    }
  },
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    if( this.$route.params.id ){
      this.getSite();
    }else{
      this.getCompanies();
      //this.getCountries();
    }

    this.items = [];
  },
  methods: {
    getCompanies(){
      Swal.fire({
        title: "Cargando compañías",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/organizations.php',
        {
          params: {
            request: 'getOrganizationsForCombos',
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.companies = response.data;
          Swal.close();
          this.getCountries();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar las compañías! Por favor cargue este módulo de nuevo.", "error");
        }
      });
    },
    getCountries(){
      Swal.fire({
        title: "Cargando países",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let app = this;
      axios
      .get(
        window.serverPath+'dist/mvw/controllers/countries.php',
        {
          params: {
            request: 'getCountries',
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.countries = response.data;
          Swal.close();
          if(this.$route.params.id){
            this.getStatesByCountryID();
          }
        }else{
          Swal.fire("Ooops!", "No fue posible cargar los países! Por favor cargue este módulo de nuevo.", "error");
        }
      });
    },
    getStatesByCountryID(){
      let app = this;
      Swal.fire({
        title: "Cargando estados",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/states.php',
        {
          params: {
            request: 'getStatesByCountryID',
            idCountry: this.form.id_country,
            token: this.user.token
          }
        }
      )
      .then(response => {
        if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
        if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
        if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }

        if( response.status == 200 ){
          app.states = response.data;
          Swal.close();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar los estados! Por favor cargue este módulo de nuevo.", "error");
        }
      });
    },
    getSite(){
      Swal.fire({
        title: "Cargando sitio.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/sites.php',
        {
          params: {
            request: 'getSite',
            id: this.$route.params.id,
            token: this.user.token
          }
        }
      )
      .then(response => {
        if( response.status == 200 ){
          app.site = response.data;

          this.form.id_country                    = app.site.id_country;
          this.form.id_state                      = app.site.id_state;
          this.form.de_addressSite                = app.site.de_addressSite;
          this.form.de_siteRepresentantEmail      = app.site.de_siteRepresentantEmail;
          this.form.de_siteHumanResourcesEmail    = app.site.de_siteHumanResourcesEmail;
          this.form.de_siteContactEmail           = app.site.de_siteContactEmail;
          this.form.nm_site                       = app.site.nm_site;

          this.form.num_latitude                  = app.site.num_latitude;
          this.form.num_longitude                 = app.site.num_longitude;

          this.num_latitude                       = app.site.num_latitude;
          this.num_longitude                      = app.site.num_longitude;

          if(app.site.yn_isCorporativeSite == 1){
            this.form.yn_isCorporativeSite        = true;  
          }else{
            this.form.yn_isCorporativeSite        = false;
          }
          Swal.close();
          this.getCompanies();
          this.getCountries();
        }else{
          Swal.fire("Ooops!", "No fue posible cargar la información del sitio! Por favor intente de nuevo.", "error");
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    saveSite(e) {
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_site = this.$route.params.id;
        }

        Swal.fire({
          title: "Guardando información.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/sites.php', {
          request: 'saveSite',
          data: this.form,
          token: this.user.token
        })
        .then(function (response) {
          let action = "";
          if( response.data === "OK" ){
            action = "guardado";
          }
          if( response.data === "UPDATED" ){
            action = "actualizado";
          }

          Swal.fire("Buen trabajo!", "Su sitio fue correctamente "+action+"!", "success");
          app.$router.push({ name: 'sites' });
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Al parecer ocurrió un error, por favor intente de nuevo.", "error");
        });
      }
    },
    setPosition(event){
      this.form.num_latitude = event.lat;
      this.form.num_longitude = event.lng;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveSite">
              <div class="row">
                <div class="col-lg-4">
                  <h4 class="card-title">Información de ubicación</h4>
                  <p class="card-title-desc">Proporcione toda la información posible de la ubicación de su sitio para una mejor comunicación entre otros sitios.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_company">Compañía</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_company.$error }"
                          name="id_company"
                          id="id_company"
                          v-model="form.id_company"
                        >
                          <option value="">SELECCIONAR SU COMPAÑÍA</option>
                          <option v-for="(company, index) in companies" :key="index" :value="company.id_company">{{company.nm_company}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_company.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_company.required">Este campo es requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_country">País</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_country.$error }"
                          name="id_country"
                          id="id_country"
                          v-model="form.id_country"
                          @change="getStatesByCountryID"
                        >
                          <option value="">SELECCIONAR PAÍS</option>
                          <option v-for="(country, index) in countries" :key="index" :value="country.id_country">{{country.nm_country}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_country.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_country.required">Este campo es requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="id_state">Estado/Provincia</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_state.$error }"
                          name="id_state"
                          id="id_state"
                          v-model="form.id_state"
                          value=""
                        >
                          <option value="">SELECIONAR ESTADO/PROVINCIA</option>
                          <option v-for="(state, index) in states" :key="index" :value="state.id_state">{{state.nm_state}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_state.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_state.required">Este campo es requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_addressSite">Dirección</label>
                        <textarea
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_addressSite.$error }"
                          name="de_addressSite"
                          id="de_addressSite"
                          v-model="form.de_addressSite"
                          rows="3"
                          value=""
                        >
                        </textarea>
                        <div v-if="submitted && $v.form.de_addressSite.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_addressSite.required">Este campo es requerido.</span>
                          <span v-if="!$v.form.de_addressSite.minLength">Por favor ingrese entre 100 y 200 caracteres para este campo.</span>
                          <span v-if="!$v.form.de_addressSite.maxLength">Por favor ingrese entre 100 y 200 caracteres para este campo.</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group">
                            <label for="num_latitude">Latitud</label>
                            <input
                              class="form-control"
                              name="num_latitude"
                              id="num_latitude"
                              v-model="form.num_latitude"
                              type="text"
                              placeholder="Coordenada de latitud"
                              value=""
                            />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="form-group">
                            <label for="num_longitude">Longitud</label>
                            <input
                              class="form-control"
                              name="num_longitude"
                              id="num_longitude"
                              v-model="form.num_longitude"
                              type="text"
                              placeholder="Coordenada de longitud"
                              value=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <h4 class="card-title">Datos de contacto</h4>
                  <p class="card-title-desc">Provea toda la información de contacto para mantener mejor comunicación entre sus sitios.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="de_siteRepresentantEmail">Correo de representante</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteRepresentantEmail.$error }"
                          name="de_siteRepresentantEmail"
                          id="de_siteRepresentantEmail"
                          v-model="form.de_siteRepresentantEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteRepresentantEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteRepresentantEmail.required">Correo de representante requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_siteHumanResourcesEmail">Correo de recursos humanos</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteHumanResourcesEmail.$error }"
                          name="de_siteHumanResourcesEmail"
                          id="de_siteHumanResourcesEmail"
                          v-model="form.de_siteHumanResourcesEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteHumanResourcesEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteHumanResourcesEmail.required">Correo de recursos humanos requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="de_siteContactEmail">Correo de contacto</label>
                        <input
                          type="email"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.de_siteContactEmail.$error }"
                          name="de_siteContactEmail"
                          id="de_siteContactEmail"
                          v-model="form.de_siteContactEmail"
                          value=""
                        >
                        <div v-if="submitted && $v.form.de_siteContactEmail.$error" class="invalid-feedback">
                          <span v-if="!$v.form.de_siteContactEmail.required">Correo de contacto requerido.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_site">Nombre del sitio</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_site.$error }"
                          name="nm_site"
                          id="nm_site"
                          v-model="form.nm_site"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_site.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_site.required">Este campo es requerido.</span>
                          <span v-if="!$v.form.de_addressSite.minLength">Por favor ingrese entre 2 y 50 caracteres para este campo.</span>
                          <span v-if="!$v.form.de_addressSite.maxLength">Por favor ingrese entre 2 y 50 caracteres para este campo.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <b-form-checkbox v-model="form.yn_isCorporativeSite" switch class="mb-1">
                          <label>¿Este sitio es el corporativo?</label>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Ubicación del sitio</h4>
                      <Basic :lat.sync="num_latitude" :lng.sync="num_longitude" :key="componentKey" @changeMarker="setPosition"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">GUARDAR</button>
                    <router-link to="/company/sites" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCELAR</button>
                    </router-link>
                  </div>
                </div>
              </div>
          </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>